import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { isTokenValid, redirectToIdentityServer } from './TokenUtils';
import { getConfig } from './TokenConfig';

// Handles OAuth callback after identity server authentication
function SigninCallback({ setUser, setIsLoading, setIFinanceId }) {
  const navigate = useNavigate();
  const location = useLocation();
  const config = getConfig();

  useEffect(() => {
    const processProdSignin = async () => {
      try {
        // Extract ID token from URL hash parameters
        const params = new URLSearchParams(location.hash.slice(1));
        const idToken = params.get('id_token');
        
        if (idToken) {
          const decodedIdToken = jwtDecode(idToken);
          
          if (isTokenValid(decodedIdToken)) {
            // Validate nonce to prevent replay attacks
            const storedNonce = sessionStorage.getItem('auth_nonce');
            if (!storedNonce || decodedIdToken.nonce !== storedNonce) {
              throw new Error('Nonce validation failed');
            }
            
            sessionStorage.removeItem('auth_nonce');
            setUser({ idToken, decodedIdToken });
            localStorage.setItem('id_token', idToken);
            localStorage.setItem('decoded_token', JSON.stringify(decodedIdToken));
            
            // Clean URL by removing hash parameters
            window.history.replaceState({}, document.title, window.location.pathname);

            const storedId = localStorage.getItem('iFinanceId');
            if (storedId) {
              setIFinanceId(storedId);
            }

            navigate('/');
            return;
          }
        }
        
        throw new Error('Invalid or missing ID token');
      } catch (error) {
        console.error('Error processing ID token:', error);
        redirectToIdentityServer();
      }
    };

    processProdSignin();
  }, [location, navigate, setUser, setIFinanceId, config]);

  return null;
}

export default SigninCallback;